// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3537":"css/admin-app.6718","3793":"css/app.6718"}[chunkId] + ".css";
};